import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '@services/settings.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-duty-settings',
  templateUrl: './duty-settings.component.html',
  styleUrls: ['./duty-settings.component.css'],
})
export class DutySettingsComponent implements OnInit {
  pricingForm: FormGroup;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private notificationService: NotificationService
  ) {
    this.pricingForm = this.fb.group({
      dutyAmount: ['', [Validators.required, Validators.min(0)]],
      nosepadsInstallAmount: ['', [Validators.required, Validators.min(0)]],
      drillMountAmount: ['', [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
    this.settingsService.loadSettings().subscribe((settings) => {
      this.pricingForm.patchValue({
        dutyAmount: settings.dutyAmount,
        nosepadsInstallAmount: settings.nosepadsInstallAmount,
        drillMountAmount: settings.drillMountAmount,
      });
    });
  }

  save() {
    if (this.pricingForm.invalid) {
      return;
    }

    const dutyAmount = parseFloat(this.pricingForm.value.dutyAmount);
    const nosepadsInstallAmount = parseFloat(this.pricingForm.value.nosepadsInstallAmount);
    const drillMountAmount = parseFloat(this.pricingForm.value.drillMountAmount);

    if (
      [dutyAmount, nosepadsInstallAmount, drillMountAmount].some(
        (amount) => isNaN(amount) || amount < 0
      )
    ) {
      return;
    }

    this.saving = true;
    this.settingsService
      .updatePricingSettings({
        dutyAmount,
        nosepadsInstallAmount,
        drillMountAmount,
      })
      .subscribe({
        next: () => {
          this.saving = false;
          this.notificationService.show('success', 'PRICING SETTINGS SAVED');
        },
        error: () => {
          this.saving = false;
          this.notificationService.show('error', 'FAILED TO SAVE PRICING SETTINGS');
        },
      });
  }
}
